//reset session data while click on menu link
$(document).ready(function() { 
  //reset filter values for desktop
  $(document).on("click", ".ly-custom-dropdown-list", function() {  
   // localStorage.clear();
    });
  });